import { render, staticRenderFns } from "./ModificarCostoServicioComuna.vue?vue&type=template&id=dcbb311e&scoped=true&"
import script from "./ModificarCostoServicioComuna.vue?vue&type=script&lang=js&"
export * from "./ModificarCostoServicioComuna.vue?vue&type=script&lang=js&"
import style0 from "./ModificarCostoServicioComuna.vue?vue&type=style&index=0&id=dcbb311e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcbb311e",
  null
  
)

export default component.exports